const charCodes = {
    ENTER: 13,
    SPACEBAR: 32,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    ARROW_LEFT: 37
};

export default charCodes;
